/* eslint-disable @typescript-eslint/naming-convention */
import 'mobx-react-lite'
import React, { createContext, useEffect } from 'react'

import { rootStore } from '../store/Root.store'
import FontStyles from '../styles/fonts.styles'
import { ContentRouter } from './ContentRouter'
import { Toasts } from './Toast/Toast'
import { GlobalStyle } from '../styles/global.styles'
import { Helmet } from './Helmet'

export const StoreContext = createContext(rootStore)

export const App: React.FC = () => {
  const [routerKey, setRouterKey] = React.useState(0)

  useEffect(() => {
    window.addEventListener('message', (message) => {
      if (
        message.origin ===
        'https://payment-authorization.prod.identity.signicat.global/'
      ) {
        const data = JSON.parse(message.data)
        const { authorized, branding } = data

        if (authorized) {
          if (authorized === 'true') {
            setRouterKey((prev) => prev + 1)
          }
          localStorage.setItem('authorized', authorized)
        }

        if (branding) {
          localStorage.setItem('branding', JSON.stringify(branding))
        }
      }
    })

    return () => {
      window.removeEventListener('message', () => {})
    }
  }, [])
  return (
    <StoreContext.Provider value={rootStore}>
      <Helmet />
      <FontStyles />
      <GlobalStyle
        bgColor={'#fff'}
        fontFamily={rootStore.AppState.theme.globals.fontFamily}
        linkColor={rootStore.AppState.theme.globals.linkColor}
        checkboxColor={rootStore.AppState.theme.globals.checkboxColor}
        checkboxColorActive={
          rootStore.AppState.theme.globals.checkboxColorActive
        }
        color={rootStore.AppState.theme.container.color}
        container={rootStore.AppState.theme.container}
      />
      <div className="App">
        <Toasts />
        <ContentRouter key={routerKey} />
      </div>
    </StoreContext.Provider>
  )
}
